export default {
  UNREAD_MESSAGES_TITLE: "You have unread messages",
  UNREAD_MESSAGES_VH_SUFFIX: "unread messages",
  CLOSE_BUTTON: "Close and end the chat",
  POPOUT_BUTTON: "Pop-out chat window",
  TOGGLE_MINIMISED: {
    OPEN: "Minimise chat window",
    CLOSED: "Show chat window"
  }
};